// A place to keep your menu scripting (ex. toggling a mobile menu)
(function($){
 

	// Listen for window resizing to handle mobile menu
	$(window).resize(handleWindowResize);
	handleWindowResize();

	function handleWindowResize() {
	    if ($(window).width() <= 1100) {
	        $(".primary-menu").addClass("mobile-primary");
	        $("body").addClass("mobile");
	    }
	    else {
	    	$(".primary-menu").removeClass("mobile-primary");
	        $("body").removeClass("mobile");
	    }
	}

	//On mobile, toggle the dropdowns
	$(".mobile-primary .mega-inner > .has-mega-menu > a").click(function (e) {
		e.stopPropagation();
		e.preventDefault();

		$(this).next().toggleClass('sub-active');
		$(this).next().children().find('.subnav').toggleClass('open');
	});

	// Handle menu interactions
	$(".main-menu-toggle").click(function() {
		mainNav();
	});

	function mainNav() {
		$(".main-menu-toggle").toggleClass("cross");
		$("body").toggleClass("modal-open");
		$(".main-navigation").toggleClass("open");
		$(".mobile-primary").toggleClass("open");

	}


	//Prevent actions on clicks of top-level menu items on wide screens (mobile is already being handled above)
	$(".has-mega-menu a [href=\\#]").click(function(e) {
		e.preventDefault();
	});


})(jQuery);
